// Переключатель светлой и тёмной темы.
//
// Пока пользователь не выбрал тему явно, атрибут data-theme не ставится
// и оформление следует за настройкой системы (см. Base/_tokens.scss).

(function () {
    "use strict";

    type Theme = "dark" | "light";

    const STORAGE_KEY = "theme";
    const root = document.documentElement;

    function read(): Theme | null {
        try {
            const value = localStorage.getItem(STORAGE_KEY);
            return value === "dark" || value === "light" ? value : null;
        } catch {
            return null;
        }
    }

    function write(value: Theme | null): void {
        try {
            if (value) {
                localStorage.setItem(STORAGE_KEY, value);
            } else {
                localStorage.removeItem(STORAGE_KEY);
            }
        } catch {
            /* Приватный режим или запрет на хранение — выбор не сохранится,
               но переключение в рамках текущей страницы работает. */
        }
    }

    function systemTheme(): Theme {
        return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches
            ? "dark"
            : "light";
    }

    function current(): Theme {
        const attribute = root.getAttribute("data-theme");
        return attribute === "dark" || attribute === "light" ? attribute : systemTheme();
    }

    // Кнопка-переключатель — toggle button: aria-pressed="true", когда
    // включена тёмная тема.
    function syncToggles(): void {
        const pressed = current() === "dark" ? "true" : "false";

        document.querySelectorAll("[data-theme-toggle]").forEach(function (el) {
            el.setAttribute("aria-pressed", pressed);
        });
    }

    function apply(theme: Theme): void {
        root.setAttribute("data-theme", theme);
        write(theme);
        syncToggles();
    }

    document.addEventListener("click", function (event) {
        const target = event.target;

        if (!(target instanceof Element)) {
            return;
        }

        if (!target.closest("[data-theme-toggle]")) {
            return;
        }

        event.preventDefault();
        apply(current() === "dark" ? "light" : "dark");
    });

    if (window.matchMedia) {
        window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", function () {
            if (!read()) {
                root.removeAttribute("data-theme");
            }

            syncToggles();
        });
    }

    // Начальное состояние кнопки: сервер не знает тему и отдаёт
    // aria-pressed="false"; скрипт выполняется с defer — кнопки уже в DOM.
    syncToggles();
})();
